module.exports = __webpack_public_path__ + "static/img/female-bg-tr.b8415498.png";